import { IgnoreSubscriptionsLink } from './IgnoreSubscriptionsLink'
import { MutationsTracker } from './MutationsTracker'
import { getShouldTrackMutationPredicates } from './shouldTrackMutationPredicates'
import {
  getIsMutationSuccessfulPredicates,
  getSubscriptionsToMutationsMap,
} from './subscriptionsMutationsMap'

export const createIgnoreSubscriptionsLink = () =>
  new IgnoreSubscriptionsLink({
    tracker: new MutationsTracker(),
    isMutationSuccessful: getIsMutationSuccessfulPredicates,
    shouldTrackMutation: getShouldTrackMutationPredicates,
    subscriptionsToMutationsMap: getSubscriptionsToMutationsMap(),
  })
